import { ReactNode, useEffect, useState } from 'react';
import { AboutHeroSection,  AboutTeam,  AwardsSection, Footer, LanguageToggle, Navbar } from '../../components';
import { useScroll } from 'framer-motion';

import { motion } from 'framer-motion'
import { FADE_BOTTOM } from '../../animations';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Head from 'next/head';
import Image from 'next/image';

const AboutIcon = "/icons/about_us.png"
const VisionIcon = "/icons/vision.png"
const MissionIcon = "/icons/mission.png"

interface AboutProps {
}

export async function getStaticProps({ locale }:any) {
  return {
    props: {
      ...(await serverSideTranslations(locale, [
        'common',
      ])),
      // Will be passed to the page component as props
    },
  }
}

export default function About({ }: AboutProps) {
  const [navbarTransparent, setNavbarTransparent] = useState(true)
  const { scrollYProgress, scrollY } = useScroll()
  const { t } = useTranslation();
  const router = useRouter();
  const { asPath: pathname } = router;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    scrollYProgress.on('change', (e) => {
      if (scrollY.get() >= 100) {
        setNavbarTransparent(false)
      } else {
        setNavbarTransparent(true)
      }
    })

  }, [])

  return (
    <div className="dark:bg-background-900 bg-[#eef3fc] min-h-screen w-full font-roboto overflow-hidden" >
           <Head>
        <title>{t(`About DeepNeuronic`)}</title>
        <meta name="description" content={t("Discover DeepNeuronic's AI-driven technology elevating industry standards. From real-time traffic monitoring, crowd detection, to instant threat alerts, our advanced surveillance systems are tailored for diverse scenarios. Try our seamless, customizable, and feature-rich platform now!" )} />
      </Head>

      <Navbar transparent={navbarTransparent} />
      <AboutHeroSection />
      <AwardsSection />

      <section className="mt-28 w-full dark:bg-neutral-900 bg-white dark:text-white text-neutral-600 p-20" >
        <div className="w-full mx-auto max-w-7xl " >
          <h2 className="text-lg md:text-2xl" >{t("about_title")}</h2>
          {/* About */}
          <motion.div className="flex gap-6 items-center justify-between"
            initial={FADE_BOTTOM.initial}
            whileInView={FADE_BOTTOM.final}
            transition={{
              duration: 0.4,
              delay: 0.3
            }}
            viewport={{ once: true }}
          >
            <motion.div className="w-full max-w-[800px]"

            >
              <p>
                {t("about_p1")}
              </p>
            </motion.div>
            <div className="w-96 flex justify-center" >
              <Image width={192} height={150} className="w-48 invert dark:invert-0" src={AboutIcon} alt="about" />
            </div>
          </motion.div>

          {/* vision */}
          <motion.div className="mt-12 flex gap-6 items-center justify-between"
            initial={FADE_BOTTOM.initial}
            whileInView={FADE_BOTTOM.final}
            transition={{
              duration: 0.4,
              delay: 0.3
            }}
            viewport={{ once: true }}
          >
            <motion.div className="w-full max-w-[800px]"

            >
              <p>
                {t("about_p2")}
              </p>
              <p className="mt-2" >
                {t("about_p3")}
              </p>
            </motion.div>

            <div className="w-96 h-[150px] flex justify-center relative" >
              <Image width={160} height={150} className="w-40 invert dark:invert-0" src={VisionIcon} alt="about" />
              {/* <svg width="150" height="150" viewBox="0 0 150 150" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M133.195 27.7619C132.926 27.422 132.644 27.0822 132.351 26.7423C125.445 18.504 116.842 11.8525 107.131 7.24144C97.4191 2.63041 86.8272 0.168422 76.0777 0.0234376C75.7144 0.0117188 75.3628 0 74.9995 0C74.6363 0 74.2847 0.0117188 73.9214 0.0234376C63.1314 0.169833 52.501 2.65056 42.7608 7.29515C33.0205 11.9397 24.4012 18.6381 17.4953 26.9298C17.2985 27.1413 17.1146 27.3643 16.9445 27.5978C16.9358 27.6155 16.9238 27.6313 16.9094 27.6447C5.97455 41.0043 0 57.7364 0 75.0004C0 92.2645 5.97455 108.997 16.9094 122.356C16.9238 122.37 16.9358 122.385 16.9445 122.403C17.1146 122.637 17.2985 122.86 17.4953 123.071L17.507 123.083C24.4121 131.372 33.0298 138.067 42.768 142.71C52.5063 147.353 63.1342 149.832 73.9214 149.977C74.641 150.001 75.3581 150.001 76.0777 149.977C86.8272 149.832 97.4191 147.37 107.131 142.759C116.842 138.148 125.445 131.497 132.351 123.259C132.644 122.919 132.926 122.579 133.195 122.239C144.065 108.895 150 92.2111 150 75.0004C150 57.7898 144.065 41.1057 133.195 27.7619ZM116.59 72.9496C116.473 61.8365 114.869 50.789 111.82 40.1018C118.496 37.9949 124.873 35.037 130.793 31.301C140.16 43.2043 145.445 57.8082 145.863 72.9496H116.59ZM77.0503 4.20706C89.5777 5.49613 100.476 18.4337 106.769 37.3713C97.0821 40.0301 87.0949 41.4399 77.0503 41.5667V4.20706ZM72.9488 41.5667C62.9042 41.4399 52.917 40.0301 43.2298 37.3713C49.5228 18.4337 60.4213 5.49613 72.9488 4.20706V41.5667ZM72.9488 45.6682V72.9496H37.511C37.6229 62.2429 39.1398 51.5972 42.0228 41.2854C52.1012 44.0647 62.4949 45.5377 72.9488 45.6682ZM72.9488 77.0512V104.333C62.4949 104.463 52.1012 105.936 42.0228 108.715C39.1398 98.4036 37.6229 87.7579 37.511 77.0512H72.9488ZM72.9488 108.434V145.794C60.4213 144.505 49.5228 131.567 43.2298 112.63C52.917 109.971 62.9042 108.561 72.9488 108.434ZM77.0503 108.434C87.0949 108.561 97.0821 109.971 106.769 112.63C100.476 131.567 89.5777 144.505 77.0503 145.794V108.434ZM77.0503 104.333V77.0512H112.488C112.376 87.7618 110.859 98.4114 107.976 108.727C97.9006 105.933 87.5055 104.456 77.0503 104.333ZM77.0503 72.9496V59.3089V45.6682C87.5055 45.5447 97.9006 44.0676 107.976 41.2737C110.859 51.5895 112.376 62.2391 112.488 72.9496H77.0503ZM128.144 28.1134C122.653 31.5344 116.756 34.2548 110.59 36.2112C106.09 22.8283 99.3278 12.1876 91.277 5.98832C105.557 9.37656 118.437 17.106 128.144 28.1134ZM58.7221 5.98832C50.6713 12.1876 43.9095 22.8283 39.4095 36.2112C33.2474 34.2487 27.3511 31.5328 21.8547 28.1252C31.5564 17.1082 44.4379 9.37347 58.7221 5.98832ZM19.2063 31.2892C25.1254 35.033 31.5022 37.9988 38.179 40.1135C35.1289 50.7966 33.5247 61.8403 33.4095 72.9496H4.13585C4.55455 57.8047 9.83877 43.197 19.2063 31.2892ZM33.4095 77.0512C33.5247 88.1606 35.1289 99.2043 38.179 109.887V109.899C31.5007 112.005 25.1234 114.967 19.2063 118.712C9.83877 106.804 4.55455 92.1962 4.13585 77.0512H33.4095ZM21.8547 121.876C27.3511 118.468 33.2474 115.752 39.4095 113.79C43.9095 127.173 50.6713 137.813 58.7221 144.013C44.438 140.627 31.5564 132.893 21.8547 121.876ZM91.277 144.013C99.3278 137.813 106.09 127.173 110.59 113.79C116.756 115.746 122.653 118.466 128.144 121.887C118.437 132.895 105.557 140.624 91.277 144.013ZM130.793 118.7C124.873 114.964 118.496 112.006 111.82 109.899C114.869 99.2119 116.473 88.1644 116.59 77.0512H145.863C145.445 92.1926 140.16 106.797 130.793 118.7Z" fill="white" />
              </svg> */}

              {/* <svg className="absolute top-0" width="150" height="150" viewBox="0 0 150 150" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M133.195 27.7619C132.926 27.422 132.644 27.0822 132.351 26.7423C125.445 18.504 116.842 11.8525 107.131 7.24144C97.4191 2.63041 86.8272 0.168422 76.0777 0.0234376C75.7144 0.0117188 75.3628 0 74.9995 0C74.6363 0 74.2847 0.0117188 73.9214 0.0234376C63.1314 0.169833 52.501 2.65056 42.7608 7.29515C33.0205 11.9397 24.4012 18.6381 17.4953 26.9298C17.2985 27.1413 17.1146 27.3643 16.9445 27.5978C16.9358 27.6155 16.9238 27.6313 16.9094 27.6447C5.97455 41.0043 0 57.7364 0 75.0004C0 92.2645 5.97455 108.997 16.9094 122.356C16.9238 122.37 16.9358 122.385 16.9445 122.403C17.1146 122.637 17.2985 122.86 17.4953 123.071L17.507 123.083C24.4121 131.372 33.0298 138.067 42.768 142.71C52.5063 147.353 63.1342 149.832 73.9214 149.977C74.641 150.001 75.3581 150.001 76.0777 149.977C86.8272 149.832 97.4191 147.37 107.131 142.759C116.842 138.148 125.445 131.497 132.351 123.259C132.644 122.919 132.926 122.579 133.195 122.239C144.065 108.895 150 92.2111 150 75.0004C150 57.7898 144.065 41.1057 133.195 27.7619ZM116.59 72.9496C116.473 61.8365 114.869 50.789 111.82 40.1018C118.496 37.9949 124.873 35.037 130.793 31.301C140.16 43.2043 145.445 57.8082 145.863 72.9496H116.59ZM77.0503 4.20706C89.5777 5.49613 100.476 18.4337 106.769 37.3713C97.0821 40.0301 87.0949 41.4399 77.0503 41.5667V4.20706ZM72.9488 41.5667C62.9042 41.4399 52.917 40.0301 43.2298 37.3713C49.5228 18.4337 60.4213 5.49613 72.9488 4.20706V41.5667ZM72.9488 45.6682V72.9496H37.511C37.6229 62.2429 39.1398 51.5972 42.0228 41.2854C52.1012 44.0647 62.4949 45.5377 72.9488 45.6682ZM72.9488 77.0512V104.333C62.4949 104.463 52.1012 105.936 42.0228 108.715C39.1398 98.4036 37.6229 87.7579 37.511 77.0512H72.9488ZM72.9488 108.434V145.794C60.4213 144.505 49.5228 131.567 43.2298 112.63C52.917 109.971 62.9042 108.561 72.9488 108.434ZM77.0503 108.434C87.0949 108.561 97.0821 109.971 106.769 112.63C100.476 131.567 89.5777 144.505 77.0503 145.794V108.434ZM77.0503 104.333V77.0512H112.488C112.376 87.7618 110.859 98.4114 107.976 108.727C97.9006 105.933 87.5055 104.456 77.0503 104.333ZM77.0503 72.9496V59.3089V45.6682C87.5055 45.5447 97.9006 44.0676 107.976 41.2737C110.859 51.5895 112.376 62.2391 112.488 72.9496H77.0503ZM128.144 28.1134C122.653 31.5344 116.756 34.2548 110.59 36.2112C106.09 22.8283 99.3278 12.1876 91.277 5.98832C105.557 9.37656 118.437 17.106 128.144 28.1134ZM58.7221 5.98832C50.6713 12.1876 43.9095 22.8283 39.4095 36.2112C33.2474 34.2487 27.3511 31.5328 21.8547 28.1252C31.5564 17.1082 44.4379 9.37347 58.7221 5.98832ZM19.2063 31.2892C25.1254 35.033 31.5022 37.9988 38.179 40.1135C35.1289 50.7966 33.5247 61.8403 33.4095 72.9496H4.13585C4.55455 57.8047 9.83877 43.197 19.2063 31.2892ZM33.4095 77.0512C33.5247 88.1606 35.1289 99.2043 38.179 109.887V109.899C31.5007 112.005 25.1234 114.967 19.2063 118.712C9.83877 106.804 4.55455 92.1962 4.13585 77.0512H33.4095ZM21.8547 121.876C27.3511 118.468 33.2474 115.752 39.4095 113.79C43.9095 127.173 50.6713 137.813 58.7221 144.013C44.438 140.627 31.5564 132.893 21.8547 121.876ZM91.277 144.013C99.3278 137.813 106.09 127.173 110.59 113.79C116.756 115.746 122.653 118.466 128.144 121.887C118.437 132.895 105.557 140.624 91.277 144.013ZM130.793 118.7C124.873 114.964 118.496 112.006 111.82 109.899C114.869 99.2119 116.473 88.1644 116.59 77.0512H145.863C145.445 92.1926 140.16 106.797 130.793 118.7Z" strokeWidth={2} stroke={"url(#gradient2)"} />

                <defs>
                  <motion.linearGradient
                    animate={{
                      x1: [150, 0],
                      x2: [100, 0],
                      y1: [150, 100],
                      y2: [130, 100]
                    }}
                    transition={{
                      duration: 3,
                      repeat: Infinity,
                      ease: 'linear'
                    }} id="gradient"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#2084F9" stopOpacity="0" />
                    <stop offset="1" stopColor="#2084F9" />
                    <stop stopColor="#f142b6" stopOpacity="0" />
                  </motion.linearGradient>

                  <motion.linearGradient
                    animate={{
                      x1: [0, 100],
                      x2: [0, 150],
                      y1: [100, 130],
                      y2: [100, 150]
                    }}
                    transition={{
                      duration: 3,
                      repeat: Infinity,
                      ease: 'linear',
                    }} id="gradient2"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#2084F9" stopOpacity="0" />
                    <stop offset="1" stopColor="#2084F9" />
                    <stop stopColor="#f142b6" stopOpacity="0" />
                  </motion.linearGradient>

                </defs>
              </svg> */}

            </div>
          </motion.div>

          {/* mission */}
          <motion.div className="mt-12 flex gap-6 items-center justify-between"
            initial={FADE_BOTTOM.initial}
            whileInView={FADE_BOTTOM.final}
            transition={{
              duration: 0.4,
              delay: 0.3
            }}
            viewport={{ once: true }}
          >
            <div className="w-full max-w-[800px]" >
              <p>
              {t("about_p4")}
              </p>
            </div>
            <div className="w-96 flex justify-center" >
              <Image width={160} height={150} className="w-40 invert dark:invert-0" src={MissionIcon} alt="about" />
            </div>
          </motion.div>
        </div>

      </section>
      <AboutTeam />
      <div className="flex h-24 w-full items-center justify-center">
      </div>
      <Footer />
      <LanguageToggle />
    </div>
  );
}
